import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import VueMeta from 'vue-meta';

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSession from 'vue-session'
import VueMoment from 'vue-moment'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import JsonCSV from 'vue-json-csv'
import Multiselect from 'vue-multiselect'
import VueSocialauth from 'vue-social-auth'
import { LoaderPlugin } from 'vue-google-login'


import FontAwesome from 'font-awesome/css/font-awesome.css'
import SwiperCSS from 'swiper/swiper-bundle.css'
//import VueFacebookPixel from 'vue-analytics-facebook-pixel'
//import ua from 'universal-analytics'

import App from "./App.vue";
import router from "./router";
import store from "./store";

//import ProductZoomer from 'vue-product-zoomer'
import PicZoom from 'vue-piczoom'
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
//import 'vue-zoomer/dist/vue-zoomer.css'


import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'



import './assets/style.scss'
import './assets/responsiv.scss'

/* +++ import for Backend +++ */
//import CKEditor from '@ckeditor/ckeditor5-vue';
//import VueTrix from "vue-trix"
import VueSocialSharing from 'vue-social-sharing'
import VueHtmlToPaper from 'vue-html-to-paper';

import VueZoomer from 'vue-zoomer'

/* +++++++++++++++++++++++++ */
import VueTreeNavigation from 'vue-tree-navigation';



Vue.use(VueSidebarMenu)
//Vue.use(VueFacebookPixel)
//Vue.use(ProductZoomer)
Vue.use(VueMeta)
Vue.use(VueAxios, axios)
Vue.use(VueMoment);
Vue.use(VueSession, {
  persist : true
});
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(SwiperCSS);
Vue.use(FontAwesome);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

Vue.use(VueTreeNavigation);
Vue.component('downloadCsv',JsonCSV);
Vue.component('multiselect', Multiselect);
Vue.component('PicZoom', PicZoom);
Vue.use(VueZoomer);


Vue.use(VueSocialauth, {

  providers: {
    github: {
      clientId: 'xvxcv',
      redirectUri: '/auth/github/callback' // Your client app URL
    },facebook: {
      clientId: '1159672198103693',
	  secret:'324a4bf96503a885d2ee36097ccc165d',
      redirectUri: 'https://localhost:8080/auth/facebook/callback' // Your client app URL
    },google: {
      clientId:'77916340824-u8s0akii4brk0m2mgrsapseka9vavs7e.apps.googleusercontent.com',
      client:'77916340824-u8s0akii4brk0m2mgrsapseka9vavs7e.apps.googleusercontent.com',
	  secret:'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',
      redirectUri: 'https://localhost:8080/auth/google/callback' // Your client app URL
    },google2: {
      clientId:'77916340824-juoq1ekrefkmmh9gn8ea5ttavvodmvcu.apps.googleusercontent.com',
      client:'77916340824-juoq1ekrefkmmh9gn8ea5ttavvodmvcu.apps.googleusercontent.com',
	  secret:'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',
      redirectUri: 'https://central.alluraa.com/auth/google/callback' // Your client app URL
    }
	
  }
});

const hostUri = window.location.protocol + "//" + window.location.host;
//console.log('hostUri:'+hostUri);
Vue.use(LoaderPlugin, {
        //client_id: '77916340824-u8s0akii4brk0m2mgrsapseka9vavs7e.apps.googleusercontent.com',
		//redirect_uri: 'https://localhost:8080/auth/google/callback',		
		client_id: "77916340824-31o82n7993uunfke2temn1q6lrfrmp7e.apps.googleusercontent.com",
	    //redirect_uri: "https://www.alluraa.com/auth/google/callback",
		redirect_uri: hostUri+'/auth/google/callback'		
    });
	
	
/* +++ BackEnd Useg +++ */
//Vue.use(VueAxios, axios)
//Vue.use(VueSession)
//Vue.use(VueMoment);
//Vue.use(BootstrapVue)
//Vue.use(BootstrapVueIcons)
//Vue.use(CKEditor);
//Vue.use(VueTrix);
Vue.use(VueSocialSharing);
const options = {
	name: '_blank',
	specs: [
            'fullscreen=yes',
            'titlebar=yes',
            'scrollbars=yes'
	],
	styles: [
            'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
            'https://unpkg.com/kidlat-css/css/kidlat.css'
	]
}
Vue.use(VueHtmlToPaper, options);


/* +++++++++++++++++++ */

Vue.config.productionTip = false;






//Vue.analytics.fbq.init('1107794496230809');
//var visitor = ua('G-J5D103H4N0');
//visitor.pageview("/").send()

Vue.component("tree-item", {
  template: "#item-template",
  props: {
      item: { type: Object }
  },
  data: function() {
      return {
        isOpen: false
      };
  },
  computed: {
      isFolder: function() {
        return this.item.children && this.item.children.length;
      }
  },
  methods: {
      toggle: function() {
        if (this.isFolder) {
            this.isOpen = !this.isOpen;
        }
      },
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
  data(){
		return{
access_key: '',
reload_duration: 30*1000,
flash_msg: {'type':'', 'msg':''},
default_shipping: 45,
free_shipping: 499,
customer_info: {
access_key: '',
user_id: 0,
billing: {
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  address: '',
  city: '',
  state: '',
  pincode: '',
  country: 'IN',
},
shipping: {
  firstname: '',
  lastname: '',
  phone: '',
  address: '',
  city: '',
  state: '',
  pincode: '',
  country: 'IN',
},
wallet: {
  cr_amount: 0,
  dr_amount: 0,
  blance: 0,
  cr_amount_cb: 0,
  dr_amount_cb: 0,
  blance_cb:0,
  total_blance:0,
  expiresdate: '',
},

},
cart: {
items: [],
subtotal: 0,
shipping: 45,
totalprice: 0,
quantity: 0,
wallet_balance_applied:0,
coupon_applied:0,
coupon:[],
},
emptycart: {
items: [],
subtotal: 0,
shipping: 45,
totalprice: 0,
quantity: 0,
wallet_balance_applied:0,
coupon_applied:0,
coupon:[],
},
addtocartAlert:'',
commission: {'agent':10, 'total': 15},
quickview_data: {
		price: 0,
special_price: 0,
gallery_images: [],
qty: 1
},
productviewlink:'', 
order_status: [
	{id: 1, label: 'Pending Payment', slug: 'pending' , paid: 0, report: 0, color: 'danger'},
	{id: 2, label: 'Processing', slug: 'processing', paid: 0, report: 0, color: 'warning'},
	{id: 3, label: 'Shipped', slug: 'shipped', paid: 0, report: 0, color: 'primary'},
	{id: 4, label: 'On Hold', slug: 'on-hold', paid: 0, report: 0, color: 'secondary'},
	{id: 5, label: 'Completed', slug: 'completed', paid: 0, report: 0, color: 'success'},
	{id: 6, label: 'Cancelled', slug: 'cancelled', paid: 0, report: 0, color: 'danger'},
	{id: 7, label: 'Refunded', slug: 'refunded', paid: 0, report: 0, color: 'dark'},
	{id: 8, label: 'Failed', slug: 'failed', paid: 0, report: 0, color: 'dark'},
],
payment_status: [
	{id: 0, label: 'Un paid', slug: 'unpaid' , paid: 0, color: 'danger'},
	{id: 1, label: 'Paid', slug: 'paid', paid: 0, color: 'success'},
	{id: 2, label: 'Refunded', slug: 'refunded', paid: 0, color: 'success'}
],
delivery_status: [ 
	{id: 0, label: 'Pending', slug: 'pending' , paid: 0, color: 'danger'},
	{id: 1, label: 'Shiping', slug: 'shiping' , paid: 0, color: 'warning'},
	{id: 2, label: 'Shipped', slug: 'shipped' , paid: 0, color: 'warning'},
	{id: 4, label: 'In Transit', slug: 'in_transit' , paid: 0, color: 'warning'},
	{id: 5, label: 'Out For Delivery', slug: 'out_for_delivery' , paid: 0, color: 'dark'},	
	{id: 6, label: 'Delivered', slug: 'delivered', paid: 0, color: 'success'},
	{id: 7, label: 'Undelivered', slug: 'undelivered', paid: 0, color: 'success'},
	{id: 8, label: 'Order Cancelled', slug: 'order_cancelled', paid: 0, color: 'danger'},
	{id: 9, label: 'Order Refunded', slug: 'order_refunded', paid: 0, color: 'dark'}
],
cancellation_reason: [
	{id: 0, label: 'I have changed my mind', slug: 'I have changed my mind' , paid: 0, color: 'warning'},
	{id: 1, label: 'I want to change address for the order', slug: 'I want to change address for the ordder' , paid: 0, color: 'warning'},
	{id: 2, label: 'I have purchased the product elsewhere', slug: 'I have purchased the product elsewhere' , paid: 0, color: 'warning'},
	{id: 3, label: 'I want to cancel due to product quality issues', slug: 'I want to cancel due to product quality issues', paid: 0, color: 'warning'},
	{id: 4, label: 'Price for the product has decreased', slug: 'Price for the product has decreased', paid: 0, color: 'warning'},
	{id: 5, label: 'I want to change my phone number', slug: 'I want to change my phone number', paid: 0, color: 'warning'},
	{id: 6, label: 'Expected delivery time is very long', slug: 'Expected delivery time is very long', paid: 0, color: 'warning'}
],return_reason: [
	{id: 0, label: 'Incorrect Product or Size Ordered', slug: 'Incorrect Product or Size Ordered' , paid: 0, color: 'warning'},
	//{id: 1, label: 'Product No Longer Needed', slug: 'Product No Longer Needed' , paid: 0, color: 'warning'},
	{id: 1, label: 'Product Does Not Match Description on Website or in Catalog', slug: 'Product Does Not Match Description on Website or in Catalog' , paid: 0, color: 'warning'},
	{id: 2, label: 'Product Did Not Meet Customers Expectations', slug: 'Product Did Not Meet Customers Expectations', paid: 0, color: 'warning'},
	{id: 3, label: 'Company Shipped Wrong Product or Size', slug: 'Company Shipped Wrong Product or Size', paid: 0, color: 'warning'}
],
return_status: [ 
	{id: 0, label: 'Return', slug: 'return' , paid: 0, color: 'warning'},
	{id: 1, label: 'Return Approved', slug: 'return_approved' , paid: 0, color: 'success'},
	{id: 2, label: 'Return Cancelled', slug: 'return_cancelled' , paid: 0, color: 'danger'},
	
],
gender_list: [ 
	{id: 0, label: 'Men', slug: 'Men' , paid: 0, color: 'success'},
	{id: 1, label: 'Women', slug: 'Women' , paid: 0, color: 'success'},
	{id: 2, label: 'Unisex', slug: 'Unisex' , paid: 0, color: 'success'},
	
],
country_origin: [ 
	{id: 0, label: 'India', slug: 'India' , paid: 0, color: 'success'},
	{id: 1, label: 'China', slug: 'China' , paid: 0, color: 'success'},
	{id: 2, label: 'Japan', slug: 'Japan' , paid: 0, color: 'success'},
	{id: 3, label: 'United States', slug: 'United States' , paid: 0, color: 'success'},
	{id: 4, label: 'South Korea', slug: 'South Korea' , paid: 0, color: 'success'},
	{id: 5, label: 'Russia', slug: 'Russia' , paid: 0, color: 'success'},
	{id: 6, label: 'Germany', slug: 'Germany' , paid: 0, color: 'success'},
	
],

stateList:['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Andaman and Nicobar Islands','Chandigarh','Delhi','Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry','Dadra and Nagar Haveli'],
stateList2: [ 
	{id: 0, label: 'Andhra Pradesh', slug: 'Andhra Pradesh' , paid: 0, color: 'success'},
	{id: 1, label: 'Andaman and Nicobar Islands', slug: 'Andaman and Nicobar Islands' , paid: 0, color: 'success'},
	{id: 2, label: 'Arunachal Pradesh', slug: 'Arunachal Pradesh' , paid: 0, color: 'success'},
	{id: 3, label: 'Assam', slug: 'Assam' , paid: 0, color: 'success'},
	{id: 4, label: 'Bihar', slug: 'Bihar' , paid: 0, color: 'success'},
	{id: 5, label: 'Chandigarh', slug: 'Chandigarh' , paid: 0, color: 'success'},
	{id: 6, label: 'Chhattisgarh', slug: 'Chhattisgarh' , paid: 0, color: 'success'},	
	{id: 7, label: 'Delhi', slug: 'Delhi' , paid: 0, color: 'success'},
	{id: 8, label: 'Goa', slug: 'Goa' , paid: 0, color: 'success'},
	{id: 9, label: 'Gujarat', slug: 'Gujarat' , paid: 0, color: 'success'},
	{id: 10, label: 'Haryana', slug: 'Haryana' , paid: 0, color: 'success'},
	{id: 11, label: 'Himachal Pradesh', slug: 'Himachal Pradesh' , paid: 0, color: 'success'},
	{id: 12, label: 'Jammu and Kashmir', slug: 'Jammu and Kashmir' , paid: 0, color: 'success'},
	{id: 13, label: 'Jharkhand', slug: 'Jharkhand' , paid: 0, color: 'success'},
	{id: 14, label: 'Karnataka', slug: 'Karnataka' , paid: 0, color: 'success'},
	{id: 15, label: 'Kerala', slug: 'Kerala' , paid: 0, color: 'success'},
	{id: 16, label: 'Ladakh', slug: 'Ladakh' , paid: 0, color: 'success'},
	{id: 17, label: 'Lakshadweep', slug: 'Lakshadweep' , paid: 0, color: 'success'},
	{id: 18, label: 'Madhya Pradesh', slug: 'Madhya Pradesh' , paid: 0, color: 'success'},
	{id: 19, label: 'Maharashtra', slug: 'Maharashtra' , paid: 0, color: 'success'},
	{id: 20, label: 'Manipur', slug: 'Manipur' , paid: 0, color: 'success'},
	{id: 21, label: 'Meghalaya', slug: 'Meghalaya' , paid: 0, color: 'success'},
	{id: 22, label: 'Mizoram', slug: 'Mizoram' , paid: 0, color: 'success'},
	{id: 23, label: 'Nagaland', slug: 'Nagaland' , paid: 0, color: 'success'},
	{id: 24, label: 'Odisha', slug: 'Odisha' , paid: 0, color: 'success'},
	{id: 25, label: 'Punjab', slug: 'Punjab' , paid: 0, color: 'success'},
	{id: 26, label: 'Puducherry', slug: 'Puducherry' , paid: 0, color: 'success'},
	{id: 27, label: 'Rajasthan', slug: 'Rajasthan' , paid: 0, color: 'success'},
	{id: 28, label: 'Sikkim', slug: 'Sikkim' , paid: 0, color: 'success'},
	{id: 29, label: 'Tamil Nadu', slug: 'Tamil Nadu' , paid: 0, color: 'success'},
	{id: 30, label: 'Telangana', slug: 'Telangana' , paid: 0, color: 'success'},
	{id: 31, label: 'Tripura', slug: 'Tripura' , paid: 0, color: 'success'},
	{id: 32, label: 'Uttar Pradesh', slug: 'Uttar Pradesh' , paid: 0, color: 'success'},
	{id: 33, label: 'Uttarakhand', slug: 'Uttarakhand' , paid: 0, color: 'success'},
	{id: 34, label: 'West Bengal', slug: 'West Bengal' , paid: 0, color: 'success'},	
	{id: 35, label: 'Dadra & Nagar Haveli and Daman & Diu', slug: 'Dadra & Nagar Haveli and Daman & Diu' , paid: 0, color: 'success'},	
],
INFLUENCER:'influencer',
INFLUENCER_TEXT:'Influencer',
REFER_AMOUNT:100,




WEBURL: 'https://www.alluraa.com:3000/webapi/',
WEBURLNEW: 'https://www.alluraa.com/new/webapi/',
MEDIAAPI: 'https://www.alluraa.com/new/',
MEDIAPATH: 'https://www.alluraa.com/media/',




/* +++++ addUrl for Backend ++++++++++ */
	//WEBURL: 'http://localhost:3001/webapi/',
	//APPURL: 'http://localhost:8080/',
	//WEBAPI: 'http://localhost:3001/',
	//NEWAPIURL: 'http://localhost:8002/allura/backup/new/',
	//URLPATH: 'http://localhost:3001/',	

	APPURL: 'https://www.alluraa.com/',
	WEBAPI: 'https://www.alluraa.com:3000/',
	NEWAPIURL: 'https://www.alluraa.com/new/',
	URLPATH: 'https://www.alluraa.com:3000/',
	//MEDIAPATH: 'https://www.alluraa.com/media/',

/* +++++++++++++++ */


// WEBURLNEW: 'http://localhost:3001/',
// MEDIAAPI: 'http://localhost:8002/allura/backup/new/',
// MEDIAPATH: 'http://localhost:8002/allura/backup/frontend/media/',

		ACTYPE: "MU",
		status_options: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
		page_perm_options: [{ value: 'enabled', text: 'Enabled' },{ value: 'view', text: 'View' },{ value: 'add', text: 'Add' },{ value: 'edit', text: 'Edit' },{ value: 'delete', text: 'Delete' }],
		page_report_perm_options: [{ value: 'enabled', text: 'Enabled' },{ value: 'view', text: 'View' },{ value: 'export', text: 'Export' }],
		share: {
			products: [],
			recommended: [],
			favorites: [],
			topselling: [],
			filteritems: [],
			shareitems: [],
			shared_list: [],
			shopshareitems: [],
			history: [],
			link: '',
			linkItems:[],
			social: 'whatsapp',
			iamiconfor:'',
			socialSocial: '',
		},
		orderplaceId:'',
			
			
			

		} 
  },
  created(){
    console.log("CREATED NEW");
    if(!this.$session.has('cart')){
      this.$session.start();
      var _cart = {
        items: [],
        subtotal: 0,
        shipping: 45,
        totalprice: 0,
        quantity: 0,
		wallet_balance_applied:0,
		coupon_applied:0,
		coupon:[]
      }
      this.cart = _cart;
      this.$session.set('cart', _cart);
      console.log('SESSION GENERATED');
    }else{
      this.cart = this.$session.get('cart');
      console.log('SESSION EXIST');
    }
	
	/* ---------Cart Shop Session ---------------*/
	this.$root.share.iamiconfor='';
	this.$root.share.link = '';
	this.$root.share.linkItems = [];
	if(!this.$session.has('cartShop')){
      this.$session.start();
      var _cartShop = []
      this.share.shareitems = _cartShop;
      this.$session.set('cartShop', _cartShop);
     // console.log('SESSION GENERATED');
    }else{ 
      this.share.shareitems = this.$session.get('cartShop');
      //console.log('SESSION EXIST');
    }	
	
	if(!this.$session.has('cartShopitem')){
      this.$session.start();
      var _cartShopitem = []
      this.share.shopshareitems = _cartShopitem;
      this.$session.set('cartShopitem', _cartShopitem);
     // console.log('SESSION GENERATED');
    }else{ 
      this.share.shopshareitems = this.$session.get('cartShopitem');
      //console.log('SESSION EXIST');
    }
	/* ------------------------ */
    if(this.$session.has('customer_info')){
      this.customer_info = Object.assign(this.customer_info, this.$session.get('customer_info'));
    }
  },
  methods: {
    filterorderstatus(value){
      if(value == null){
        return [{color: '', label: ''}];
      }
      return this.order_status.filter(function (status) {
        if(status.slug === value){
          return status;
        }
      });
    },
    filterpaymentstatus(value){
      if(value == null){
        return [{color: '', label: ''}];
      }
      return this.payment_status.filter(function (status) {
        if(status.slug === value){
          return status;
        }
      });
    },
    filterdeliverystatus(value){
      if(value == null){
        return [{color: '', label: ''}];
      }
      return this.delivery_status.filter(function (status) {
        if(status.slug === value){
          return status;
        }
      });
    },
    addtofavourite(productdata){
      var self = this;
      console.log(JSON.stringify(self.$root.cart));

      if(self.$root.customer_info.access_key != ''){

          self.axios.post(self.WEBURL+'customer-addfavourites', {
              accesskey: self.$root.customer_info.access_key,
              product_id: productdata.product_id
          }).then(function (response) {
              if(response.data.error == 0 || response.data.error == '0'){
                  productdata.heart = 1;
                  self.$bvToast.toast('Product added to favourite successfully!', {
                    title: `Added To favourite`,
                    variant: 'success',
                    toaster: 'b-toaster-bottom-right',
                    solid: true,
                    appendToast: true
                    /*noAutoHide: true*/
                  })
              }else if(response.data.error == 9){
                  self.$root.forceLogout(response.data.message);
              }
          }).catch(function (error) {
              alert(error);
          });
      }
    },
    logout(){
      if(this.$session.has('customer_info')){
        this.$session.remove('customer_info');
        this.customer_info = '';

        var _cart = {
          items: [],
          subtotal: 0,
          shipping: 45,
          totalprice: 0,
          quantity: 0,
          wallet_balance_applied: 0,
		  coupon_applied:0,
		  coupon:[]
        }
        this.cart = _cart;
        this.$session.set('cart', _cart);

        this.$bvToast.toast('done!', {
          title: `Logout`,
          variant: 'danger',
          toaster: 'b-toaster-bottom-right',
          solid: true,
          appendToast: true
        })
      }
    },
    is_logged_in(){
        console.log(this.$session.get('access_key'));

        if(this.$session.get('access_key') == '' || this.$session.get('access_key') == undefined){
                this.$session.destroy();
                this.$router.push('/');
                return 1;
        }else{
                return 0;
        }
    },
    tofixed(value, param){
			//return (value).toFixed(param);
			param=0;
			let val = (value/1).toFixed(param).replace(',', '.')
			return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    currency(){
      return '₹';
    }, 
/* 	 tofixed(value, param){
			return (value).toFixed(param);
    },
    currency(value){
      return '₹ '+value;
    }, */
    showQuickView(item){
      var _tmp = Object.assign({}, item);
      _tmp.gallery_images = JSON.parse(item.gallery_images);
      _tmp.qty = 1;

      this.quickview_data = _tmp;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
    showLoginModal(){
      this.$emit('bv::show::modal', 'login-modal')
    },
    showRegisterModal(){
      this.$emit('bv::show::modal', 'register-modal')
    },
    chkperm(option,perm){
			var userinfo = this.$session.get('user_info');
			if(userinfo){
				if(userinfo.role == 1){
					return 1;
				}
				var options = userinfo.options;
				if(options['page_'+option]){
					if(options['page_'+option].indexOf(perm) > -1){
						return 1;
					}
				}
			}
			
			return 0;
    },
	forceLogout(msg){
			var self = this;
			this.$bvModal.msgBoxOk(msg, {
				title: 'Security Issue',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'Logout',
				okOnly: true,
				footerClass: 'p-2',
				backdrop: 'static',
				hideHeaderClose: true,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.$session.destroy();
					
					self.$router.push('/')
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
	},
    cartTotal(){
      return this.cart.total;
    },
    resetCart(){
      this.cart = Object.assign({}, this.emptycart);
      this.$session.set('cart', this.cart);
	   this.addtoMycart();
    },
    removeCart(id){
      for (var i = 0; i < this.cart.items.length; i++) {
        if(this.cart.items[i].id == id){
          this.cart.items.splice(i,1);
          
          this.$bvToast.toast('Product removed successfully!', {
            title: `Add To Cart`,
            variant: 'danger',
            toaster: 'b-toaster-bottom-right',
            solid: true,
            appendToast: true
            /*noAutoHide: true*/
          })
          break;
        }
      }
      this.cart.totalprice = 0;
      this.cart.quantity = 0;
      this.cart.subtotal = 0;
      this.cart.shipping = 45;
	  this.cart.coupon_applied=0;
	  this.cart.coupon=[];
      for (i = 0; i < this.cart.items.length; i++) {
        this.cart.quantity += this.cart.items[i].qty;
        if(this.cart.items[i].special_price){
          this.cart.subtotal += this.cart.items[i].special_price * this.cart.items[i].qty;
        }else{
          this.cart.subtotal += this.cart.items[i].price * this.cart.items[i].qty;
        }
      }
      if(this.cart.subtotal > this.free_shipping) this.cart.shipping = 0;
      this.cart.totalprice = this.cart.subtotal + this.cart.shipping;
	  
	  /*  Discount Apply */
		if(this.cart.wallet_balance_applied>0){
			this.cart.wallet_balance_applied=0;
			//this.cart.totalprice =Number(this.cart.totalprice) - Number(this.cart.wallet_balance_applied);
			
		}
	  /* ---------------- */

      this.$session.set('cart', this.cart);
      //console.log(this.cart);
	  this.addtoMycart();
    },
    updateCart(product, qty,variant='',variantId='',shareid='',share_user_id=''){
		//console.log(variant+'---vvvv---'+variantId+'---'+product.id+'---'+shareid+'---'+share_user_id);
      if(!product.id){
        return;
      }
	   if(product.id =='1051'){
        this.free_shipping = 0;
      }
	  
      var exist = false;
	  var cartId ='';
	  var orgPId ='';
	 // var productIdOrg = product.id;
		cartId = product.id;
		orgPId = product.id;
		//console.log('cartId:'+cartId);
		   if(product.product_type==2){
				
			for(var itm = 0; itm < product.variation_attributes.length; itm++) {
				let attrname = product.variation_attributes[itm];
				let attrval ='';
				if(variant!=''){
					attrval = variant[itm]; 
				}
				//console.log(attrname+'---'+attrval+'---'+variant);
				if(attrval==''){
					this.addtocartAlert="Please select a "+attrname+" to proceed";	
					return;
				}else{
					if(variantId!=''){ /* If varientId */
						cartId +='_'+variantId;
					}
				}
			}
		  }
		  
		  //console.log('cartId2:'+cartId);
	  var i = 0;
     
      for (i; i < this.cart.items.length; i++) {
		  
		  
        if(this.cart.items[i].id == cartId){
          exist = true;
          
          this.cart.items[i].qty = qty;

          if(qty == 0){
            this.cart.items.splice(i,1);
          }

          break;
        }
      }
      if(!exist){
		  
		product.variations_selected = variant;
        product.qty = qty;
        product.shareid = shareid;
        product.share_user_id = share_user_id;
        product.orgPId = orgPId;
		//product.id = cartId;
        this.cart.items.push(product);
		//product.id = productIdOrg;
		this.cart.items[i].id=cartId;
		//console.log('cartIdLep'+i);
		

        this.$bvToast.toast('Product added successfully!', {
          title: `Add To Cart`,
          variant: 'success',
          toaster: 'b-toaster-bottom-right',
          solid: true,
          appendToast: true
          /*noAutoHide: true*/
        })
      }else{
        this.$bvToast.toast('Product already added in cart!', {
          title: `Add To Cart`,
          variant: 'warning',
          toaster: 'b-toaster-bottom-right',
          solid: true,
          appendToast: true
          /*noAutoHide: true*/
        })
      }
      
      this.cart.totalprice = 0;
      this.cart.quantity = 0;
      this.cart.subtotal = 0;
      this.cart.shipping = 45;
	  this.cart.coupon_applied=0;
	  this.cart.coupon=[];
      for (i = 0; i < this.cart.items.length; i++) {
        this.cart.quantity += this.cart.items[i].qty;
        if(this.cart.items[i].special_price){
          this.cart.subtotal += this.cart.items[i].special_price * this.cart.items[i].qty;
        }else{
          this.cart.subtotal += this.cart.items[i].price * this.cart.items[i].qty;
        }
      }
      if(this.cart.subtotal > this.free_shipping) this.cart.shipping = 0;
      this.cart.totalprice = this.cart.subtotal + this.cart.shipping;
	  
	   /*  Discount Apply */
		if(this.cart.wallet_balance_applied>0){
				this.cart.wallet_balance_applied =0;
			//this.cart.totalprice =Number(this.cart.totalprice) - Number(this.cart.wallet_balance_applied);
		}
	  /* ---------------- */

      this.$session.set('cart', this.cart);
      //console.log(this.cart);
			
		/* --- SHOW CART PANEL --- */
		 this.$root.$emit('bv::toggle::collapse', 'cartPanel');
		
		  setTimeout(function(){
					
					 console.log('close SLide01');
					 document.querySelector('.close').click();
                    
					var objCart = document.getElementById("cartPanel")
					objCart.style.display = "none";
					
					 
					/*  console.log('collection:'+collection.length);
						for (let i = 0; i < collection.length; i++) {
							//if(collection[i].style.display==''){
								collection[i].style.display = "none";
							//}
						  
						}  */
					//objCart.querySelectorAll('.b-sidebar-backdrop').style.display = "none";
					//document.getElementsByClassName('bg-dark').style.display = "none";
					/* objCart.getElementsByClassName('b-sidebar-backdrop').style.display = "none";
					querySelectorAll(".parent > .child1") */
					//document.getElementById("cartPanel").collapse.hide;
					/* console.log('close SLide02');
                    this.$root.$emit('bv::toggle::collapse.close', 'cartPanel'); */
                    //this.$root.$emit('bv::toggle::hidden', 'cartPanel');
					
                }, 5000);
		/* ---------------- */
		
	  /* --- Save in Mycart --- */
	  this.addtoMycart();
	  /* **** */
    },
	updateCartqty(product, qty){
      if(!product.id){
        return;
      }
      var exist = false;
     
	  this.cart.coupon_applied=0;
	  this.cart.coupon=[];
	  //console.log('product.stock_qty:'+product.stock_qty+'---qty:'+qty);
	  if(product.stock_qty <= qty){
		this.$bvToast.toast('Maximum quantity available is ' + product.stock_qty, {
          title: `Add To Cart`,
          variant: 'warning',
          toaster: 'b-toaster-bottom-right',
          solid: true,
          appendToast: true
          /*noAutoHide: true*/
        })
		return;
	  }
	  
      for (var i = 0; i < this.cart.items.length; i++) {
        if(this.cart.items[i].id == product.id){
          exist = true;
          
          this.cart.items[i].qty = qty;

          if(qty == 0){
            this.cart.items.splice(i,1);
          }

          break;
        }
      }
      if(!exist){
        product.qty = qty;
        this.cart.items.push(product);

        this.$bvToast.toast('Qty added successfully!', {
          title: `Add To Cart`,
          variant: 'success',
          toaster: 'b-toaster-bottom-right',
          solid: true,
          appendToast: true
          /*noAutoHide: true*/
        })
      }else{
        this.$bvToast.toast('Quantity Updated Successfully!', {
          title: `Add To Cart`,
          variant: 'warning',
          toaster: 'b-toaster-bottom-right',
          solid: true,
          appendToast: true
          /*noAutoHide: true*/
        })
      }
      
      this.cart.totalprice = 0;
      this.cart.quantity = 0;
      this.cart.subtotal = 0;
      this.cart.shipping = 45;
      for (i = 0; i < this.cart.items.length; i++) {
        this.cart.quantity += this.cart.items[i].qty;
        if(this.cart.items[i].special_price){
          this.cart.subtotal += this.cart.items[i].special_price * this.cart.items[i].qty;
        }else{
          this.cart.subtotal += this.cart.items[i].price * this.cart.items[i].qty;
        }
      }
      if(this.cart.subtotal > this.free_shipping) this.cart.shipping = 0;
      this.cart.totalprice = this.cart.subtotal + this.cart.shipping;
	  
	  /*  Discount Apply */
		if(this.cart.wallet_balance_applied>0){
			
			//this.cart.totalprice =Number(this.cart.totalprice) - Number(this.cart.wallet_balance_applied);
			var blance = this.$root.customer_info['wallet'].blance;
			 if(blance>this.cart.totalprice){
				this.cart.wallet_balance_applied = this.cart.totalprice;
				this.cart.totalprice =this.cart.totalprice - this.cart.totalprice;				 
			 }else{				 
				//this.cart.wallet_balance_applied = blance;
				this.cart.totalprice =Number(this.cart.totalprice) - Number(this.cart.wallet_balance_applied);
			 }			
			
		}
	  /* ---------------- */

      this.$session.set('cart', this.cart);
      /* console.log(this.cart); */
	  this.addtoMycart();
    },
	/* apply wallet Amount*/
	applywallet(blance,applytype=''){
		  if(!blance){
			return;
		  }
		  console.log(blance+'---'+applytype);
		  
		  if(applytype=='remove'){			  
			  
			  this.cart.totalprice =Number(this.cart.totalprice) + Number(this.cart.wallet_balance_applied);
			  this.cart.wallet_balance_applied = 0;
		  }else{
			 if(blance>this.cart.totalprice){
				this.cart.wallet_balance_applied = this.cart.totalprice;
				this.cart.totalprice =this.cart.totalprice - this.cart.totalprice;				 
			 }else{				 
				this.cart.wallet_balance_applied = blance;
				this.cart.totalprice =this.cart.totalprice - blance;
			 }			
		  }
		  
		  
		 /*  this.cart.totalprice = 0;
		  this.cart.quantity = 0;
		  this.cart.subtotal = 0;
		  this.cart.shipping = 45;
		  for (i = 0; i < this.cart.items.length; i++) {
			this.cart.quantity += this.cart.items[i].qty;
			if(this.cart.items[i].special_price){
			  this.cart.subtotal += this.cart.items[i].special_price * this.cart.items[i].qty;
			}else{
			  this.cart.subtotal += this.cart.items[i].price * this.cart.items[i].qty;
			}
		  }
		  if(this.cart.subtotal > this.free_shipping) this.cart.shipping = 0;
		  this.cart.totalprice = this.cart.subtotal + this.cart.shipping; */
		  
		 
			
		  this.$session.set('cart', this.cart);
		  /* console.log('totalprice'+this.cart.totalprice);
		  console.log('subtotal'+this.cart.subtotal);
		  console.log(this.cart); */
	},

    checkout(){
      this.$f7router.navigate('/checkout');
    },
	addtofavouriteNotlogin(){
		if(this.$root.customer_info.access_key == ''){
			this.$router.push({
				name: 'Login',
				params: {
					redirect: this.$route.path
				}
			});
		}
	}, /* ===========Share============== */
	removeShare(item){
      console.log("REMOVE ");
        for (let index = 0; index < this.share.shareitems.length; index++) {
            const element = this.share.shareitems[index];
         
            if(element.id == item.id){
                this.share.shareitems.splice(index, 1);
				this.share.shopshareitems.splice(index, 1);


                console.log('REMOVE ITEM');
				 this.$bvToast.toast('Product removed successfully!', {
					title: `Add To Cart`,
					variant: 'danger',
					toaster: 'b-toaster-bottom-right',
					solid: true,
					appendToast: true,
					noAutoHide: true
				  })
                break;
            }
        }
		 this.$session.set('cartShop', this.share.shareitems);
		 this.$session.set('cartShopitem', this.share.shopshareitems);
    },
    updateShare(item){
		// console.log('ddd'+item.id+'---'+this.share.shareitems.length);
		 if(!item.id){
			return;
		  }
		  var exist = false;
		  var i = 0;
		   if(this.share.shareitems.length<4){ 
              //this.share.shareitems.push(item);
			  for (i; i < this.share.shareitems.length; i++) {
				if(this.share.shareitems[i].id == item.id){
				   exist = true;
				  this.$bvToast.toast('Product already added in Shop!', {
					  title: `Add To Shop`,
					  variant: 'warning',
					  toaster: 'b-toaster-bottom-right',
					  solid: true,
					  appendToast: true
					  /*noAutoHide: true*/
					});

				  break;
				}
			  }
			  if(!exist){
				this.share.shareitems.push(item);
				this.share.shopshareitems.push(item);
				
				this.$bvToast.toast('Product added successfully!', {
				  title: `Add To Shop`,
				  variant: 'success',
				  toaster: 'b-toaster-bottom-right',
				  solid: true,
				  appendToast: true
				  /*noAutoHide: true*/
				});
			  }
          }else{
          
			console.log('Max 4 product can share!');
          
			this.$bvToast.toast('Max 4 product can share!', {
				  title: `Add To Shop`,
				  variant: 'warning',
				  toaster: 'b-toaster-bottom-right',
				  solid: true,
				  appendToast: true
				  
				});
			
            
          } 
		
		/* if (e.target.checked) {
			  if(this.share.shareitems.length<4){
				  this.share.shareitems.push(item);
			  }else{
				e.preventDefault();
				e.target.checked = '';
				alert('Max 4 product can share!');
				//e.preventDefault();
			  }
			  
		  } else {
			  for (let index = 0; index < this.share.shareitems.length; index++) {
				  const element = this.share.shareitems[index];
			   
				  if(element.id == item.id){
					  this.share.shareitems.splice(index, 1);
					  break;
				  }
			  }
			  //this.share_products.splice(this.share_products.indexOf({'id':item.id}), 1);
		  } */
		  this.$session.set('cartShop', this.share.shareitems);
		  this.$session.set('cartShopitem', this.share.shopshareitems);
      //console.log(JSON.stringify(this.share.shareitems));
    }, 
	shareProduct(){
            var self = this;
            if(self.$root.customer_info.access_key != ''){

		  /* self.axios.post(self.WEBURL+'share', { */
		 self.axios.post(self.NEWAPIURL+'secureapi/share', {
			  accesskey: self.$root.customer_info.access_key,
			  items : JSON.stringify(self.$root.share.shareitems)
		  }).then(function (response) {
			  if(response.data.error == 0 || response.data.error == '0'){
				 self.$root.share.link = response.data.result.sharelink; 
				 self.$root.share.linkItems = self.$root.share.shareitems;
				 //self.$router.push('/agent/share-links');
				// self.$root.share.shareitems=[];
				if(response.data.result.sharelink!=''){
					self.$root.$emit('bv::show::modal', 'showShareModalcart');
				}
				 var _cartShop = [];
				  self.share.shareitems = _cartShop;
				  self.$session.set('cartShop', _cartShop);
				  
				  var _cartShopitem = [];
				  self.share.shopshareitems = _cartShopitem;
				  self.$session.set('cartShopitem', _cartShopitem);

				 /*  self.$bvToast.toast('Product added to favourite successfully!', {
					title: `Added To favourite`,
					variant: 'success',
					toaster: 'b-toaster-bottom-right',
					solid: true,
					appendToast: true
					noAutoHide: true
				  }) */
			  }else if(response.data.error == 9){
				  self.$root.forceLogout(response.data.message);
			  }else{
				   self.$bvToast.toast(response.data.message, {
					title: `Add To Shop`,
					variant: 'warning',
					toaster: 'b-toaster-bottom-right',
					solid: true,
					appendToast: true,
					noAutoHide: true
				  }) 
			  }
		  }).catch(function (error) {
			  alert(error);
			 
		  });
	  }
		/* 
		

		var url = self.$root.SERVICE_URL+'share';
		
		var o = {};
		o.accesskey = self.$root.accesskey;
		o.items = JSON.stringify(self.$root.share.shareitems);
		app.request.post(url, o, function (data) {
			console.log(JSON.parse(data));
			var res = JSON.parse(data);
			if(res.error == 0){
				self.$root.share.link = res.result.sharelink;
				self.$f7router.navigate('/agent/share');
			}else{
				alert('Error in share link! Try again later!');
			}
		}); */
	},
	shareProductLater(){
		var self = this;
		if(self.$root.customer_info.access_key != ''){

		  self.axios.post(self.WEBURL+'addmyshop', {
			  accesskey: self.$root.customer_info.access_key,
			  items : JSON.stringify(self.$root.share.shareitems)
		  }).then(function (response) {
			  if(response.data.error == 0 || response.data.error == '0'){
				self.$root.share.link = response.data.result.sharelink;
				//self.$router.push('/agent/share-links');
				// self.$root.share.shareitems=[];
				var _cartShop = [];
				self.share.shareitems = _cartShop;
				self.$session.set('cartShop', _cartShop);

				var _cartShopitem = []
				this.share.shopshareitems = _cartShopitem;
				this.$session.set('cartShopitem', _cartShopitem);

				
				 self.$bvToast.toast('Product added to Shop successfully!', {
					title: `Added To Shop`,
					variant: 'success',
					toaster: 'b-toaster-bottom-right',
					solid: true,
					appendToast: true,
					noAutoHide: true
				  });
				  self.$router.push('/agent/my-shop');
			  }else if(response.data.error == 9){
				  self.$root.forceLogout(response.data.message);
			  }else{
				   self.$bvToast.toast(response.data.message, {
					title: `Added To Shop`,
					variant: 'warning',
					toaster: 'b-toaster-bottom-right',
					solid: true,
					appendToast: true,
					noAutoHide: true
				  }) 
			  }
		  }).catch(function (error) {
			  alert(error);
			 
		  });
	  }
		
	},

		removeShareshop(item){ 
		  console.log("REMOVE ");
			for (let index = 0; index < this.share.shopshareitems.length; index++) {
				const element = this.share.shopshareitems[index];
			 
				if(element.id == item.id){
					this.share.shopshareitems.splice(index, 1);
					this.share.shareitems.splice(index, 1);


					console.log('REMOVE ITEM');
					 this.$bvToast.toast('Product removed successfully!', {
						title: `Add To List`,
						variant: 'danger',
						toaster: 'b-toaster-bottom-right',
						solid: true,
						appendToast: true,
						noAutoHide: true
					  })
					break;
				}
			}
			 this.$session.set('cartShopitem', this.share.shopshareitems);
			 this.$session.set('cartShop', this.share.shareitems);
		},
		updateShareshop(item){
			 //console.log('ddd'+item.id+'---'+this.share.shopshareitems.length);
			 if(!item.id){
				return;
			  }
			  var exist = false;
			  var i = 0;
			  if(this.share.shopshareitems.length<4){
				 
				  for (i; i < this.share.shopshareitems.length; i++) {
					if(this.share.shopshareitems[i].id == item.id){
					   exist = true;
					  this.$bvToast.toast('Product already added in Shop cart!', {
						  title: `Add To List`,
						  variant: 'warning',
						  toaster: 'b-toaster-bottom-right',
						  solid: true,
						  appendToast: true
						  /*noAutoHide: true*/
						});

					  break;
					}
				  }
				  if(!exist){
					this.share.shareitems.push(item);
					this.share.shopshareitems.push(item);
					
					this.$bvToast.toast('Product added successfully!', {
					  title: `Add To List`,
					  variant: 'success',
					  toaster: 'b-toaster-bottom-right',
					  solid: true,
					  appendToast: true
					  /*noAutoHide: true*/
					});
				  }
			  }else{
			   /*  e.preventDefault();
				e.target.checked = ''; */
				console.log('Max 4 product can share!');
			   // alert('Max 4 product can share!');
				
				this.$bvToast.toast('Max 4 product can share!', {
					  title: `Add To List`,
					  variant: 'warning',
					  toaster: 'b-toaster-bottom-right',
					  solid: true,
					  appendToast: true
					  /*noAutoHide: true*/
					});
				
				//e.preventDefault();
			  }
			this.$session.set('cartShop', this.share.shareitems);
			this.$session.set('cartShopitem', this.share.shopshareitems);
		  //console.log(JSON.stringify(this.share.shopshareitems));
		},
		shareProductShop(){
			var self = this;
			self.$root.share.socialSocial='';
            if(self.$root.customer_info.access_key != ''){
			  /*self.axios.post(self.WEBURL+'share', {*/
			  self.axios.post(self.NEWAPIURL+'secureapi/share', {
				  accesskey: self.$root.customer_info.access_key,
				  items : JSON.stringify(self.$root.share.shopshareitems)
			  }).then(function (response) {
				  if(response.data.error == 0 || response.data.error == '0'){
					 self.$root.share.link = response.data.result.sharelink; 
					 
					 
					 
					 /* ================Update To myshop by Shared List ======================== */
							self.axios.post(self.WEBURL+'updatemyshopWithSharedlist', {
								  accesskey: self.$root.customer_info.access_key,
								  items : JSON.stringify(self.$root.share.shopshareitems)
							  }).then(function (response) {
								  if(response.data.error == 0 || response.data.error == '0'){

									
									 /* self.$bvToast.toast('Product added to Shop successfully!', {
										title: `Added To Shop`,
										variant: 'success',
										toaster: 'b-toaster-bottom-right',
										solid: true,
										appendToast: true,
										noAutoHide: true
									  }); */
									  
								  }else if(response.data.error == 9){
									  self.$root.forceLogout(response.data.message);
								  }else{
									   self.$bvToast.toast(response.data.message, {
										title: `Added To Shop`,
										variant: 'warning',
										toaster: 'b-toaster-bottom-right',
										solid: true,
										appendToast: true,
										noAutoHide: true
									  }) 
								  }
							  }).catch(function (error) {
								  alert(error);
								 
							  });
						 
						/* ========================== */
					 
					// self.$root.share.linkItems = self.$root.share.shareitems;
					 
				
					/* var _cartShop = [];
					self.share.shopshareitems = _cartShop;
					self.$session.set('cartShopitem', _cartShop);
					
					
					  self.$bvToast.toast('Product added to favourite successfully!', {
						title: `Added To favourite`,
						variant: 'success',
						toaster: 'b-toaster-bottom-right',
						solid: true,
						appendToast: true
						noAutoHide: true
					  }) */
				  }else if(response.data.error == 9){
					  self.$root.forceLogout(response.data.message);
				  }else{
					   self.$bvToast.toast(response.data.message, {
						title: `Added To favourite`,
						variant: 'warning',
						toaster: 'b-toaster-bottom-right',
						solid: true,
						appendToast: true,
						noAutoHide: true
					  }) 
				  }
			  }).catch(function (error) {
				  alert(error);
				 
			  });
		  }
			
			
			
		},
		shareProductwithshop(){
			var self = this;
			self.$root.share.socialSocial='';
			if(self.$root.customer_info.access_key != ''){

				  /* self.axios.post(self.WEBURL+'share', { */
				 self.axios.post(self.NEWAPIURL+'secureapi/share', {
					  accesskey: self.$root.customer_info.access_key,
					  items : JSON.stringify(self.$root.share.shareitems)
				  }).then(function (response) {
					  if(response.data.error == 0 || response.data.error == '0'){
						 self.$root.share.link = response.data.result.sharelink; 
						 self.$root.share.linkItems = self.$root.share.shareitems;
						 
						 /* ================Add myshop in Shared List ======================== */
							self.axios.post(self.WEBURL+'addmyshopWithSharedlist', {
								  accesskey: self.$root.customer_info.access_key,
								  items : JSON.stringify(self.$root.share.shareitems)
							  }).then(function (response) {
								  if(response.data.error == 0 || response.data.error == '0'){
									 self.$bvToast.toast('Product added to Shop successfully!', {
										title: `Added To Shop`,
										variant: 'success',
										toaster: 'b-toaster-bottom-right',
										solid: true,
										appendToast: true,
										noAutoHide: true
									  });
									  
								  }else if(response.data.error == 9){
									  self.$root.forceLogout(response.data.message);
								  }else{
									   self.$bvToast.toast(response.data.message, {
										title: `Added To Shop`,
										variant: 'warning',
										toaster: 'b-toaster-bottom-right',
										solid: true,
										appendToast: true,
										noAutoHide: true
									  }) 
								  }
							  }).catch(function (error) {
								  alert(error);
								 
							  });
						 
						/* ========================== */
						 
						 
						 
						 //self.$router.push('/agent/share-links');
						// self.$root.share.shareitems=[];
						if(response.data.result.sharelink!=''){
							self.$root.$emit('bv::show::modal', 'showShareModalcart');
						}
						 var _cartShop = [];
						  self.share.shareitems = _cartShop;
						  self.$session.set('cartShop', _cartShop);



						  var _cartShopitem = [];
						  self.share.shopshareitems = _cartShopitem;
						  self.$session.set('cartShopitem', _cartShopitem);
						 /*  self.$bvToast.toast('Product added to favourite successfully!', {
							title: `Added To favourite`,
							variant: 'success',
							toaster: 'b-toaster-bottom-right',
							solid: true,
							appendToast: true
							noAutoHide: true
						  }) */
					  }else if(response.data.error == 9){
						  self.$root.forceLogout(response.data.message);
					  }else{
						   self.$bvToast.toast(response.data.message, {
							title: `Add To Shop`,
							variant: 'warning',
							toaster: 'b-toaster-bottom-right',
							solid: true,
							appendToast: true,
							noAutoHide: true
						  }) 
					  }
				  }).catch(function (error) {
					  alert(error);
					 
				  });
			  }
				/* 
				

				var url = self.$root.SERVICE_URL+'share';
				
				var o = {};
				o.accesskey = self.$root.accesskey;
				o.items = JSON.stringify(self.$root.share.shareitems);
				app.request.post(url, o, function (data) {
					console.log(JSON.parse(data));
					var res = JSON.parse(data);
					if(res.error == 0){
						self.$root.share.link = res.result.sharelink;
						self.$f7router.navigate('/agent/share');
					}else{
						alert('Error in share link! Try again later!');
					}
				}); */
		},
		sharepopup(){
			this.$root.$emit('bv::show::modal', 'showShareModal');
		},
		sharepopupcart(){
			this.$root.$emit('bv::show::modal', 'showShareModalcart');
		},
		sharepopupSA(){
			this.$root.$emit('bv::show::modal', 'showShareMessageModal');
		},
		previewproduct(item, index) {	
			var self =this;
				/* item, index, button */
				 //let editor = self.$refs.editor; 
				
				//productviewlink = '';
				self.$root.productviewlink='https://www.alluraa.com/product/'+item.product_id;
				//var iframe = document.getElementById('pviframe');
				
				//iframe.contentDocument.find(".header").css('display', 'none');
				
				// self.$refs.iframe.contentWindow.header.replace('header2');
				
				console.log(item+','+ index)
				self.$root.$emit('bv::show::modal', 'previewproduct');


		},
	/* ===========Share END============== */
	/* ===========Share Model Operation ============== */
		onShareClick(shareLink,chanel=''){
			var self =this;
			console.log('shareLink:'+shareLink+'chanel:'+chanel);
			self.$root.share.socialSocial= chanel;
			
			if(chanel!=''){
				self.axios.post(self.WEBURL+'setSharecount', {
								  accesskey: self.$root.customer_info.access_key,
								  shareid : shareLink
							  }).then(function (response) {
								  if(response.data.error == 0 || response.data.error == '0'){
									 
									 console.log('count'); 
								  }
							  }).catch(function (error) {
								  alert(error);
								 
							  });
				
			}
			
			
			/* self.$root.$on('share_network_open', function (network, url) {
				  // your event code
				  console.log('network:'+network+'url:'+url);
				}); */
			
			
		},
		closeMeShareModel(modelId){
			var self =this;
			console.log('dev'+modelId);
			//self.$bvModal.hide(modelId);
					//msgBoxOk
				var messageText ='You`ll be redirected and can share this link again from Shared History!';
				var titleText = 'This window will close!'
				var btnTitelYes ='Yes';				
				var btnTitelCancel ='Cancel';
				var btnOutlieYes ='outline-primary';
				var btnOutlieCancel ='outline-danger';
				if(self.$root.share.socialSocial!=''){
					messageText = 'Thanks for sharing on '+self.$root.share.socialSocial+'! Want to share on other platform.';
					titleText = 'Thanks for sharing!';
					btnTitelYes = 'Cancel';
					btnTitelCancel = 'Yes';
					
					btnOutlieYes='outline-danger';
					btnOutlieCancel ='outline-primary';
					
				}	
					
				 self.$bvModal.msgBoxConfirm(messageText, {
				  title:titleText ,
				  size: 'sm',
				  buttonSize: 'sm',
				  okVariant: btnOutlieYes,
				  cancelVariant: btnOutlieCancel,
				  okTitle: btnTitelYes,
				  cancelButton:true,
				  cancelTitle: btnTitelCancel,
				  footerClass: 'p-2',
				  hideHeaderClose: false,
				  hideFooterClose: true,
				  centered: true,
				 
				})
				  .then(value => {
					if(value == true){
						
						self.$bvModal.hide(modelId);
						if(self.$root.share.socialSocial==''){
							self.$router.push('/agent/share-links');
						}
					}else{
						self.boxTwo = value
					}
				  
					
				  })
				  .catch(err => {
					// An error occurred
					console.log(err);
				  })
			
			},
			addtoMycart(){
			  var self = this;
			 console.log(JSON.stringify(self.$root.cart));

			  if(self.$root.customer_info.access_key != ''){

				  self.axios.post(self.WEBURL+'addTomycart', {
					  accesskey: self.$root.customer_info.access_key,
					  //cartData: JSON.stringify(self.$root.cart)
					  cartData: self.$root.cart
				  }).then(function (response) {
					  if(response.data.error == 0 || response.data.error == '0'){
						  //productdata.heart = 1;
						  /* self.$bvToast.toast('Product added to favourite successfully!', {
							title: `Added To My cart`,
							variant: 'success',
							toaster: 'b-toaster-bottom-right',
							solid: true,
							appendToast: true
							noAutoHide: true
						  }) */
					  }else if(response.data.error == 9){
						  self.$root.forceLogout(response.data.message);
					  }
				  }).catch(function (error) {
					  alert(error);
				  });
			  }
		},
		/* COUPON APPLY*/
		/* apply wallet Amount*/
		applycoupon(code,applytype=''){
				
				  /* if(!code){
					return;
				  } */
					var self = this;
					
					
					if(code==''){
						self.$bvToast.toast('Invalid Coupon Code!', {
							title: 'Coupon',
							variant: 'warning',
							toaster: 'b-toaster-bottom-right',
							solid: true,
							appendToast: true,
							noAutoHide: true
						  });
						  return;

					}
					
				  console.log(code+'---'+applytype+'----'+self.tofixed(self.cart.totalprice, 2));
				   //self.cart.totalprice =Number(self.cart.subtotal);
				  if(applytype=='remove'){			  
					  
					  //this.cart.totalprice =Number(this.cart.totalprice) + Number(this.cart.wallet_balance_applied);
					  //this.cart.coupon[] = '';
					  self.cart.totalprice =Number(self.cart.coupon.totalPayable);
					  self.cart.coupon_applied =0;
					  self.cart.coupon =[];
					  self.$session.set('cart', self.cart);
				  }else{ 
						console.log('CAll'+applytype);
						self.axios.post(self.WEBAPI+'couponapi/applyCoupon', {
						 // accesskey: self.$root.customer_info.access_key,
						  //cartData: JSON.stringify(self.$root.cart)
						  code: code,
						  totalPayable:self.cart.totalprice,
					  }).then(function (response) {
						  if(response.data.error == 0 || response.data.error == '0'){
								console.log('response.data.error'+JSON.stringify(response));
								var couponResult= response.data.result.chartData;
								 self.cart.totalprice = Number(couponResult.discountPrice);
								 
								 self.cart.coupon_applied = 1;
								 self.cart.coupon = couponResult;
								 self.$session.set('cart', self.cart);
								// self.cart.totalprice =Number(self.cart.subtotal);
							  //productdata.heart = 1; 
							  /* self.$bvToast.toast('Product added to favourite successfully!', {
								title: `Added To My cart`,
								variant: 'success',
								toaster: 'b-toaster-bottom-right',
								solid: true,
								appendToast: true
								noAutoHide: true
							  }) */
						  }else if(response.data.error == 9){
							  self.$root.forceLogout(response.data.message);
						  }else{
							  self.$bvToast.toast(response.data.message, {
							title: 'Coupon',
							variant: 'warning',
							toaster: 'b-toaster-bottom-right',
							solid: true,
							appendToast: true,
							noAutoHide: true
						  }) 
							  
						  }
					  }).catch(function (error) {
						  alert(error);
					  });
					  
					 /* if(blance>this.cart.totalprice){
						this.cart.coupon = this.cart.totalprice;
						this.cart.totalprice =this.cart.totalprice - this.cart.totalprice;				 
					 }else{				 
						this.cart.wallet_balance_applied = blance;
						this.cart.totalprice =this.cart.totalprice - blance;
					 } */			
				  }
				  
				  
				 /*  this.cart.totalprice = 0;
				  this.cart.quantity = 0;
				  this.cart.subtotal = 0;
				  this.cart.shipping = 45;
				  for (i = 0; i < this.cart.items.length; i++) {
					this.cart.quantity += this.cart.items[i].qty;
					if(this.cart.items[i].special_price){
					  this.cart.subtotal += this.cart.items[i].special_price * this.cart.items[i].qty;
					}else{
					  this.cart.subtotal += this.cart.items[i].price * this.cart.items[i].qty;
					}
				  }
				  if(this.cart.subtotal > this.free_shipping) this.cart.shipping = 0;
				  this.cart.totalprice = this.cart.subtotal + this.cart.shipping; */
				  
				 
					
				  //this.$session.set('cart', this.cart);
				  /* console.log('totalprice'+this.cart.totalprice);
				  console.log('subtotal'+this.cart.subtotal);
				  console.log(this.cart); */
			},

	
  }
}).$mount("#app");
